import { Injectable, OnDestroy } from '@angular/core';
import { deepCopy } from '@common/helpers';
import { BookingSearch, INITIAL_BOOKINGSEARCH_STATE } from '@common/interfaces/booking-search/booking-search.interface';
import { BookingSearchState, BookingSearchStore } from '@common/store';
import { updateBookingSearch } from '@common/store/booking-search/booking-search.actions';
import { selectBookingSearchState } from '@common/store/booking-search/booking-search.selectors';
import { select, Store } from '@ngrx/store';
import { filter, Observable, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BookingSearchStoreService implements OnDestroy {
  private storeCurrentValueSubscription!: Subscription;
  private storeCurrentValue = INITIAL_BOOKINGSEARCH_STATE;

  constructor(private readonly store: Store<BookingSearchStore>) {
    this.storeCurrentValueSubscription = this.store.select(selectBookingSearchState).subscribe((val) => {
      this.storeCurrentValue = val?.model ?? INITIAL_BOOKINGSEARCH_STATE;
    });
  }

  getBookingSearch() {
    return this.storeCurrentValue;
  }

  public getBookingSearchObservable(): Observable<BookingSearchState> {
    return this.store.pipe(
      select(selectBookingSearchState),
      filter((data) => !!data)
    );
  }

  updateBookingSearch(value: BookingSearch) {
    this.store.dispatch(updateBookingSearch({ model: { ...deepCopy(this.storeCurrentValue), ...value } }));
  }

  ngOnDestroy(): void {
    this.storeCurrentValueSubscription.unsubscribe();
  }
}
